import actionTypes from '../../actionTypes'
import initial from '../../initial'

const resource = (state = initial.resource, action) => {
  switch (action.type) {
    case actionTypes.SET_COUNTRIES:
      return { ...state, countries: action.payload }
    case actionTypes.SET_PLANS:
      return { ...state, plans: action.payload }
    default:
      return state
  }
}

export default resource
